import { saveAs } from 'file-saver';

export const exportCSVFileWithFs = (csv: string, fileName: string) =>
  saveAs(new Blob([csv], { type: 'text/plain' }), fileName);
